<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="templateGroupId" class="my-4">{{'lang.globals.templateGroup' | translate}}</h3>
              <h3 *ngIf="!templateGroupId" class="my-4">{{'lang.globals.templateGroup.create' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name" sbAutofocus>
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <div>
                {{'lang.globals.templateVariables'|translate}}:<span class="red">*</span>
                <div *ngFor="let variable of variables; index as i">
                  <!-- one variable line -->
                  <div class="row p-1 form-group validateMe">
                    <div class="col-6 ">
                      <input type="text" class="form-control w-100 h-100" [disabled]="!!templateGroupId"
                             [(ngModel)]="variable.name"
                             [value]="variable?.name"
                             [ngModelOptions]="{standalone: true}"
                             [class.ng-valid]="((variable?.name?.length ===0 || variable?.name.length >0 && variable?.name?.trim()?.length > 0) && getUniqueStatus(i, variable))"
                             [class.ng-invalid]="(variable?.name?.length >0 && variable?.name?.trim()?.length === 0) || !getUniqueStatus(i, variable)">
                    </div>
                    <div class="col-5">
                      <select class="form-select w-100 h-100"
                              [disabled]="!!templateGroupId"
                              [(ngModel)]="variable.type"
                              [class.ng-touched]="variable.type"
                              [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let option of dropdown">{{option}}</option>
                      </select>
                    </div>
                    <div class="col-1">
                      <button *ngIf="i !== 0 && !templateGroupId" class="btn btn-danger" [disabled]="!!templateGroupId"
                              (click)="deleteRow(i)">
                        <sb-icon icon="trash"></sb-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success" *ngIf="!templateGroupId" (click)="addTemplateVariable()">
                  <sb-icon icon="plus"></sb-icon>
                </button>
              </div>
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.templateGroups)"
                           class="btn btn-default btn-lg btn-wide" type="button">{{templateGroupId ? ('lang.globals.back' | translate) : ('lang.globals.cancel' | translate)}}</button>
                <button  type="button" *ngIf="!templateGroupId" (click)="updateTemplateGroup()"
                           [disabled]="!(form.valid && checkVariables() && checkAllUnique())|| loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
